<template>
  <div class="web">
    <section class="head">

      <v-toolbar flat class="primary" dark dense>
        <v-toolbar-items class="pl-3">
          <a href="/">
            <img src="/static/logo.png" class="logo"/>
          </a>
          <v-toolbar-title v-text="title" style="height: 40px; line-height: 40px;"/>
        </v-toolbar-items>
        <v-spacer/>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-text-field
              placeholder="输入关键词检索…"
              v-model="keyword"
              flat
              clearable
              dark
              color="white"
              append-icon="search"
              @click:append="search"
              @keyup.enter="search"
              class="pt-0"
          />

          <v-btn flat @click="onLogout" v-if="userId && userId.length > 0">
            退出
          </v-btn>
          <v-btn flat :to="`/login?url=${$route.path}`" v-else >
            登录
          </v-btn>

        </v-toolbar-items>

      </v-toolbar>

      <!--PC 端-->
      <v-toolbar
          flat dark dense
          class="secondary hidden-sm-and-down">
        <v-toolbar-items>
          <v-btn
              flat
              dark
              color="white"
              v-for="nav in navigators"
              :key="nav.dbid"
              :to="`/${nav.identifier}`"
          >
            {{ nav.name }}
          </v-btn>

        </v-toolbar-items>
        <v-spacer/>

      </v-toolbar>

      <!--移动端-->
      <v-container
          grid-list-md text-xs-center
          class="hidden-md-and-up py-1">
        <v-layout row wrap>
          <v-flex
              xs3
              v-for="nav in navigators"
              :key="nav.dbid"
          >
            <router-link
                style="color:white"
                :to="`/${nav.identifier}`"
                :class="{'v-btn--active': $route.path === `/${nav.identifier}`}"
            >
              {{ nav.name }}
            </router-link>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-0">
          <v-flex xs12 class="px-4">
            <v-text-field
                label="输入关键词检索…"
                v-model="keyword"
                flat
                clearable
                dark
                append-icon="search"
                color="white"
                @click:append="search"
                @keyup.enter="search"
                hide-details
                class="pt-0"
            />
          </v-flex>
        </v-layout>
      </v-container>

    </section>

    <v-content>

      <section>
        <router-view/>
      </section>

      <v-footer class="footer">
        <v-layout row wrap justify-center>
          <v-flex xs12>
            <v-divider/>
          </v-flex>
          <v-flex xs12>
            <div class="text-xs-center mt-2">
              Copyright © 2018 <a target="_blank" href="http://www.kmust.edu.cn">昆明理工大学</a> 科技处
              <span class="ml-2">访问量：{{ visit }}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-footer>

    </v-content>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from "vuex";

export default {
  name: 'Web',
  data() {
    return {
      keyword: "",

      title: '科学技术院',
      home: {
        identifier: '',
        name: '首页'
      },
      navigators: [],
      visit: ''
    }
  },

  beforeRouteEnter(to, from, next) {
    //console.log("in App beforeRouteEnter");
    const uri = '/api/site/section';
    Vue.axios.get(uri).then(
        rsp => next(
            vm => {
              vm.navigators = [vm.home].concat(rsp.data.sections);
              vm.visit = rsp.data.visit;
            })
    )
  },
  // 路由改变前，组件就已经渲染完了
  // 逻辑稍稍不同
  // beforeRouteUpdate(to, from, next) {
  //   console.log("in App beforeRouteUpdate");
  //
  //   const uri = '/api/site/section';
  //   const vm = this;
  //   Vue.axios.get(uri).then(
  //     rsp => {
  //       vm.navigators = [this.home].concat(rsp.data);
  //       next()
  //     }
  //   )
  // },
  computed: {
    ...mapGetters([
      'userId',
      'authenticated',
      'name',
      'username',
      'passwordRaw',
      'deptId',
      'roleId',
      'deptName',
      'roleName',
      'deptRoles'
    ])
  },

  methods: {
    onLogout(){
      const answer = window.confirm('确定要退出系统吗？');
      if (answer) {
        // 退出系统，清空当前用户信息。
        this.$store.commit('logout');
      }
    },
    search() {
      //console.log("in search");
      if (this.keyword && this.keyword.trim().length > 0) {
        this.$router.push({path: '/search', query: {page: 0, keyword: this.keyword}})
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer .layout {
  background-color: rgba(4, 115, 179, 0.78);
  color: white;
}

.footer a {
  color: white;
}
</style>
